// accordions js start
function faq_taggol() {
  const accordions = document.querySelectorAll("[js-acc-item]");
  const openAccordion = (accordion) => {
    const content = accordion.querySelector("[js-acc-single-content]");
    accordion.classList.add("active");
    const scrollcontent = accordion.getAttribute("js-acc-single-trigger-scroll") || null;
    content.style.maxHeight = 'max-content';
  };
  
  const closeAccordion = (accordion) => {
    const content = accordion.querySelector("[js-acc-single-content]");
    accordion.classList.remove("active");
    if(content){
      content.style.maxHeight = null;
    }
  };
  
  accordions.forEach((accordion) => {
    const intro = accordion.querySelector("[js-acc-single-trigger]");
    const content = accordion.querySelector("[js-acc-single-content]");
    if(intro){
      intro.onclick = (e) => {
        if (content.style.maxHeight) {
          closeAccordion(accordion);
        } else {
          accordions.forEach((accordion) => closeAccordion(accordion));
          openAccordion(e.target.closest('[js-acc-item]'));
        }
      };
    }
  });   
}

(function() {
  faq_taggol();  
  (document.querySelector("[data-header-tans]") || null) && document.body.classList.add("header-transparent");
})();

// Menu Hover Start
let items = document.querySelector(".header__inline-menu").querySelectorAll("details") || null;
  if(items){
      items.forEach(item => {
       item.addEventListener("mouseover", () => {
        item.setAttribute("open", true);
         item.querySelector("ul, .megamenu-image-block.mega_menu_2").addEventListener("mouseleave", () => {
           item.removeAttribute("open");
         });
         item.addEventListener("mouseleave", () => {
           item.removeAttribute("open");
         });
       });
      });
  }
// Menu Hover end



//faq section
const faq_main_wap = document.querySelector('[faq_main_wap]') || null;
if (faq_main_wap) {
  const faq_toggles = faq_main_wap.querySelectorAll('[data-act-title]') || null;
  const faq_content_wap = faq_main_wap.querySelector('[faq_content_wap]') || null;
  const faq_content_tabs = faq_content_wap.querySelectorAll('.tabs') || null;
  const faq_dropdown = faq_main_wap.querySelector('.faq-category-dropdown') || null;
  const faq_selected = faq_main_wap.querySelector('.faq-category-selected') || null;
  const mian_tag = document.querySelector('.faq-category')|| null;
  const content = document.querySelector("[js-acc-single-content]");
  
  if (faq_content_wap) {
    faq_toggles.forEach((faq) => {
      faq.addEventListener('click', (event) => {
        faq_content_tabs.forEach((tab) => {
          tab.classList.remove('active');
          tab.style.display = 'none';
        });

        faq_toggles.forEach((toggle) => {
          toggle.classList.remove('active-tab');
        });

        const targetSelector = event.currentTarget.getAttribute('data-act-title');
        const targetTab = faq_content_wap.querySelector(targetSelector);

        if (targetTab) {
          targetTab.classList.add('active');
          targetTab.style.display = 'block';
          
         
        }
        event.currentTarget.classList.add('active-tab');
        

        if (faq_dropdown && faq_selected) {
          faq_selected.textContent = event.currentTarget.textContent.trim();
          faq_dropdown.classList.remove('open'); // Adjust class based on your dropdown open state
          mian_tag.classList.remove('active');
          if(content){
            content.style.maxHeight = null;
          }
        }
      });
    });

    if (faq_dropdown) {
      faq_dropdown.addEventListener('click', () => {
        faq_dropdown.classList.toggle('open'); // Add/remove "open" class for the dropdown
      });
    }
  }
}
//faq section end

//Product page Tab section
var tabTitles = document.querySelectorAll(".product-tab-wrapper .tab-title");
tabTitles && tabTitles.forEach(function(tabTitle, index) {
    tabTitle.addEventListener("click", function() {
        var swiperElement = tabTitle.closest(".swiper")
          , swiperInstance = swiperElement.swiper;
        swiperInstance.slideTo(index),
        tabTitles.forEach(function(tabTitle2) {
            tabTitle2.classList.remove("active"),
            tabTitle2.classList.remove("swiper-slide-active")
        }),
        tabTitle.classList.add("active"),
        tabTitle.classList.add("swiper-slide-active");
        var tab = tabTitle.getAttribute("data-tab-title")
          , tabWrappers = document.querySelectorAll(".product-tab-contents .tab-content");
        tabWrappers && tabWrappers.forEach(function(tabwrapper) {
            tabwrapper.classList.remove("active");
            var tabContent = tabwrapper.getAttribute("data-tab");
            tab == tabContent && tabwrapper.classList.add("active")
        })
    })
});
//Product page Tab section end


// =============== mobile close click event


 const closeBtn = document.querySelector("drawer-close");
const menuDrawer = document.querySelector(".menu-drawer-container summary");

if (closeBtn && menuDrawer) {
  closeBtn.addEventListener("click", function () {
    console.log(closeBtn,"closeBtn")
    menuDrawer.click();
  });
}





// --------------- pdp media mobile view

// if (window.matchMedia) {
//   const mq = window.matchMedia("(min-width: 750px)");
//   mq.addListener(handleWidthChange);
//   handleWidthChange(mq);
// }

// function handleWidthChange(mq) {
//   const sliderEl_div = document.querySelector('[data-main-pdp-swiper]');
//   if (!sliderEl_div) return; // exit if no slider on this page

//   const sliderEl = document.querySelector('[data-pdp-main-slider]');
//   if (!sliderEl) return;

//   const optionsAttr = sliderEl.getAttribute('data-slider-options');

//   if (mq.matches) {
//     // Desktop: destroy swiper if exists
//     if (sliderEl_div.swiper) {
//       sliderEl_div.swiper.destroy(true, true);
//     }
//   } else {
//     // Mobile: initialize swiper if not already initialized
//     if (!sliderEl_div.swiper) {
//       if (optionsAttr) {
//         const options = JSON.parse(optionsAttr);
//         new Swiper(sliderEl_div, options);
//       }
//     }
//   }
// }



  const stickyBtn = document.querySelector(".add-to-cart-btn button");
  const addtoBtn = document.querySelector(".product-form__submit");

  if (stickyBtn && addtoBtn) {
    stickyBtn.addEventListener("click", (e) => {
      e.preventDefault(); 
      addtoBtn.click();  
    });
  }


  const productInfo = document.querySelector("product-info");
  const addToCart = document.querySelector(".sticky-product-section"); // or your sticky section wrapper

  if (productInfo && addToCart) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) {
            addToCart.classList.add("sticky-product-add");
          } else {
            addToCart.classList.remove("sticky-product-add");
          }
        });
      },
      { threshold: 0 } // trigger when it's fully out of viewport
    );

    observer.observe(productInfo);
  }

//  custom bundal code end
function custom_addtocart_fun(product,open_drawer){
  console.log("product",product);
      fetch(`${routes.cart_add_url}`,{ 
              method: 'POST',
              headers: { "Accept": "application/json", "Content-Type": "application/json" },
              body: JSON.stringify(product)
        })
        .then(response => response.json()).then(response => {     
          console.log(response);   
        })
        .catch((error) => {
          console.error('Error:', error);
        })
        .finally((e) => {
          // console.log("finally");
          if(open_drawer){
            const this_cartDrawer = document.querySelector('cart-drawer');
           // console.log("this_cartDrawer",this_cartDrawer);
            if(this_cartDrawer){
                 this_cartDrawer.refresh(true);
            }else{
              const this_cartDrawer_ = document.querySelector('cart-items');
                if(this_cartDrawer_) this_cartDrawer_.onCartUpdate();
            }
          }
        });
    }


function custom_updatecart(updates, open_drawer) {
  fetch(`${routes.cart_update_url}`, {
    method: 'POST',
    headers: { "Accept": "application/json", "Content-Type": "application/json" },
    body: JSON.stringify({ updates }),
  })
    .then(response => response.json())
    .then(response => {
      if (open_drawer) {
        const this_cartDrawer = document.querySelector('cart-drawer');
      //  if(this_cartDrawer) this_cartDrawer.refresh(true, response.item_count);
           if(this_cartDrawer){
                 this_cartDrawer.refresh(true);
            }else{
              const this_cartDrawer_ = document.querySelector('cart-items');
                if(this_cartDrawer_) this_cartDrawer_.onCartUpdate();
            }
      }
    })
    .catch((error) => {
      console.error('Error:', error);
    });
}


(function() {
setTimeout(() => {
  if (window.location.hash === '#ContactForm') {
    const contactSection = document.querySelector('.contact_section-cust');
    const stickyHeader  = document.querySelector('header');   // ← replace with your header selector

    if (contactSection) {
      const headerHeight = stickyHeader ? stickyHeader.offsetHeight : 0;

      /* absolute position of the section in the document */
      const sectionTop = contactSection.getBoundingClientRect().top + window.pageYOffset;
      /* scroll so the section sits just below the sticky header */
      window.scrollTo({
        top: sectionTop - headerHeight,
        behavior: 'smooth'
      });
    }
  }
}, 700);  
})();

// Show popup on banner button click
  const reservationForm = document.querySelector("#reservation-form");
const bannerButtons = document.querySelectorAll(
  '.template-page-ginstube .custom-banner .banner__buttons .button, .custom_clickevent'
);


if (bannerButtons && reservationForm) {

  bannerButtons.forEach(button => {
    button.addEventListener("click", function (event) {
      event.preventDefault();
      reservationForm.style.display = "block";
      document.body.classList.add("overflow-hidden");
    });
  });

}


const closepopup = document.querySelector('.close-reservation-form');

if (closepopup && reservationForm) {
    closepopup.addEventListener("click", function (event) {
       event.preventDefault();
      reservationForm.style.display = "none";
      document.body.classList.remove("overflow-hidden");
    });
  }

// Hide popup when clicking on overlay or close button
document.addEventListener("click", function (e) {
  if (e.target.classList.contains("reservation-form-wrapper")) {
    const reservationForm = document.querySelector("#reservation-form");
    if (reservationForm) reservationForm.style.display = "none";
    document.body.classList.remove("overflow-hidden");
  }
});

document.addEventListener("DOMContentLoaded", function () {
    // 🔹 Show popup if URL contains "?contact_posted=true#ContactForm"
    if (window.location.href.includes("?contact_posted=true#ContactForm")) {
        if (reservationForm) {
            reservationForm.style.display = "block";
            document.body.classList.add("overflow-hidden");
            
            // 🔹 Remove query parameters and fragment from the URL without reloading the page
            history.replaceState(null, null, window.location.pathname);
        }
    }
});

// const items_desc = document.querySelectorAll('.tasting-descripition');

// if (items_desc.length > 0) {
//   let maxHeight = 0;

//   // 1️⃣ Find max height
//   items_desc.forEach(item => {
//     const h = item.offsetHeight;
//     if (h > maxHeight) maxHeight = h;
//   });

//   // 2️⃣ Apply as min-height
//   items_desc.forEach(item => {
//     item.style.minHeight = maxHeight + 'px';
//   });
// }

// const items_title = document.querySelectorAll('.tasting-title-wrapper');

// if (items_title.length > 0) {
//   let maxHeight = 0;

//   // 1️⃣ Find max height
//   items_title.forEach(item => {
//     const h = item.offsetHeight;
//     if (h > maxHeight) maxHeight = h;
//   });

//   // 2️⃣ Apply as min-height
//   items_title.forEach(item => {
//     item.style.minHeight = maxHeight + 'px';
//   });
// }

function setEqualHeight(selector) {
  const items = document.querySelectorAll(selector);

  if (items.length === 0) return;

  let maxHeight = 0;

  // Find max height
  items.forEach(item => {
    const h = item.offsetHeight;
    if (h > maxHeight) maxHeight = h;
  });

  // Apply as min-height
  items.forEach(item => {
    item.style.minHeight = maxHeight + 'px';
  });
}

// Call function for both selectors
setEqualHeight('.tasting-descripition');
setEqualHeight('.tasting-title-wrapper');



document.addEventListener("DOMContentLoaded", function () {

    function clean(str) {
        return str
            .replace("#", "")      // remove #
            .replace(/\s+/g, "")   // remove all spaces
            .toLowerCase();        // lowercase
    }
console.log(clean,'clean')
    // Get hash from URL
    let rawHash = window.location.hash;     // e.g. "#Gin Me"
    let hash = clean(rawHash);
console.log(hash,"hash")
    const tabs = document.querySelectorAll(".tab-nav-title");

    // --- 1️⃣ Match on page load ---
    function activateTabByText(text) {
        const cleanedText = clean(text);

        tabs.forEach(tab => {
            const link = tab.querySelector("a");
            if (!link) return;

            const cleanedLinkText = clean(link.textContent);
            console.log(cleanedLinkText,'cleanedLinkText')

            if (cleanedLinkText === cleanedText) {
                // tabs.forEach(t => t.classList.remove("active", "swiper-slide-active"));
                console.log("tab",link)
                link.click();
            }
        });
    }

    // Match current hash on load
    if (hash) {
        activateTabByText(hash);
    }

    // --- 2️⃣ When user clicks mega-menu item ---
    document.querySelectorAll(".mega-menu__link").forEach(link => {
        link.addEventListener("click", function () {
            const clickedText = this.textContent.trim();
            activateTabByText(clickedText);
        });
    });

});
